"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rteCardWithBorder = void 0;
const rteCardWithBorder = () => {
  return {
    border: "0.1rem solid rgba(0, 0, 0, 0.15)",
    backgroundColor: "rgba(234, 234, 235, 0.17)"
  };
};
exports.rteCardWithBorder = rteCardWithBorder;